import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    // Format for display in the input field
    format(date: Date, displayFormat: Object): string {
        if (date) {
            return moment(date).format('DD/MM/YYYY');
        }
        return '';
    }

    // Parse date from input string
    parse(value: any): Date | null {
        if (typeof value === 'string') {
            const date = moment(value, 'DD/MM/YYYY');
            return date.isValid() ? date.toDate() : null;
        }
        return value;
    }

    // Format for the datepicker header
    getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
        return moment.months();
    }

    // Format for the datepicker day names
    getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
        return moment.weekdays();
    }
}
